import { API } from './resources'

export default {
  getJudgeApplication: (userID) => {
    return API.get(`/users/${userID}/judgeApplication`)
  }
}
